<div class="text-center">
  <h4>Demo Classifiers</h4>
  <hr/>
  <div class="row">
    <div class="col-6">
      <select class="browser-default custom-select" id="services" (change)="changeOptionSelect();">
        <option [selected]="opencvService.currentClassifier === 'haarcascade_eye.xml'" value="haarcascade_eye.xml">Eyes
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_smile.xml'" value="haarcascade_smile.xml">
          Smile
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_fullbody.xml'"
                value="haarcascade_fullbody.xml">Body
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_profileface.xml'"
                value="haarcascade_profileface.xml">Profile face
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_upperbody.xml'"
                value="haarcascade_upperbody.xml">Upper body
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_eye_tree_eyeglasses.xml'"
                value="haarcascade_eye_tree_eyeglasses.xml">Eye tree eyeglasses
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_frontalface_alt2.xml'"
                value="haarcascade_frontalface_alt2.xml">Frontal face alt
        </option>
        <option [selected]="opencvService.currentClassifier === 'haarcascade_lowerbody.xml'"
                value="haarcascade_lowerbody.xml">Lower body
        </option>
      </select>
    </div>
    <div class="col-6">
      <h6 for="fpsOpenCV">FPS ({{opencvService.fps}})</h6>
      <input type="range" id="fpsOpenCV" name="fpsOpenCV" [(ngModel)]="opencvService.fps"
             min="1" max="30" step="1" value="{{opencvService.fps}}">
    </div>
  </div>
  <hr/>
</div>

